import {canGoBack} from "./validate";
import {useStepsContext} from "../../contexts/StepsContext";

export default function Back() {

    const { goToPrevStep } = useStepsContext();

    return (
        <button type="button"
                className="esc-ii-flex esc-ii-self-start esc-ii-items-center disabled:esc-ii-opacity-30"
                disabled={ ! canGoBack() }
                onClick={ goToPrevStep }
        >
            <span className="esc-ii-w-5 esc-ii-h-0.5 esc-ii-bg-black esc-ii-black"></span>
            <span className="esc-ii-font-bold esc-ii-uppercase esc-ii-ml-2.5 esc-ii-font-montserrat esc-ii-text-xs lg:esc-ii-text-sm">
                Back
            </span>
        </button>
    );
}
